import { useState, useCallback } from 'react';

export const useLoading = (initialState = false) => {
  const [loading, setLoading] = useState(initialState);
  const [error, setError] = useState(null);

  const startLoading = useCallback(() => {
    setLoading(true);
    setError(null);
  }, []);

  const stopLoading = useCallback(() => {
    setLoading(false);
  }, []);

  const setErrorState = useCallback((error) => {
    setError(error);
    setLoading(false);
  }, []);

  const withLoading = useCallback(async (fn) => {
    try {
      startLoading();
      const result = await fn();
      return result;
    } catch (error) {
      setErrorState(error);
      throw error;
    } finally {
      stopLoading();
    }
  }, [startLoading, stopLoading, setErrorState]);

  return {
    loading,
    error,
    startLoading,
    stopLoading,
    setError: setErrorState,
    withLoading
  };
}; 